import { render, staticRenderFns } from "./NearMatchList.vue?vue&type=template&id=475b7af2&scoped=true&"
import script from "./NearMatchList.vue?vue&type=script&lang=js&"
export * from "./NearMatchList.vue?vue&type=script&lang=js&"
import style0 from "./NearMatchList.vue?vue&type=style&index=0&id=475b7af2&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "475b7af2",
  null
  
)

export default component.exports